import React, { Component } from "react";
import PropTypes from "prop-types";
// import Link from '@material-ui/core/Link';
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "../Title";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { asyncPost } from "../../common/utils";
import { URI_PREFIX, URI } from "../../constants/index";
import {
  OTP_TYPES,
  PURPOSE,
  REQUESTER_TYPES,
  HIU_REQUESTER_ID,
  DIAGNOSTIC_REPORT,
} from "../../constants/dataconstants";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import "../../assets/styles/App.css";
import "../../assets/styles/RegisterAbha.css";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import * as moment from "moment";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import RefreshIcon from "@material-ui/icons/Refresh";

//Using css by function method.
const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 170,
  },
  button: {
    margin: theme.spacing(1),
  },
});

const defaultState = {
  requestId: "",
  patientInfo: null,
  isModalOpen: false,
  modalFor: "",
  opConsultation: false,
  dischargeSummary: false,
  diagnosticReports: false,
  prescription: false,
  isViewer: false,
  consentList: [],
  selectedConsentId: null,
};
class RegisterAbha extends Component {
  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(defaultState));
  }

  componentDidMount = () => {};

  valueChange = (e, id) => {
    //debugger;
    const __oo = {};
    __oo[id] = e.target.value;
    this.setState(__oo);
  };

  onFindPatient = async () => {
    const __oo = {
      healthId: this.state.healthId,
      requesterType: "HIU",
      requesterId: HIU_REQUESTER_ID,
    };
    const res = await asyncPost(URI.patientFind, __oo, true, false, "");
    if (res && res.status == 2000) {
      alert("Requested for patient info.");
      this.setState({
        requestId: res.data.requestId,
        modalFor: "showpatientinfo",
      });
      this.interval = setInterval(() => this.getPatientInfo(), 1000);
    } else {
      alert("Unable to find patient.");
    }
  };

  getPatientInfo = async () => {
    const __oo = {
      requestId: this.state.requestId,
    };
    const res = await asyncPost(URI.getPatientInfo, __oo, true, false, "");
    // debugger;

    if (res && res.status == 2000) {
      clearInterval(this.interval);
      this.setState({ patientInfo: res.data, healthId: res.data.healthId });
    }
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        {/* React.Fragment allow us to return multiple components or elements from a single render function another method  we would have used,by creating a <div> and put all the elements/components inside it */}
        {/* <Paper className={classes.paper} style={{ padding: '10px' }}> */}

        <Grid className="grid-container">
          <Grid item style={{ marginTop: 15 }}>
            <h5>
              <strong>Do you have an ABHA?</strong>
            </h5>
          </Grid>
          <Grid item>
            {/* To use the function method for css write the className as {classes.<className to identify the element>} */}
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/verifyabha"
              className={classes.button}
            >
              YES
            </Button>
            <Button
              variant="contained"
              color="default"
              component={Link}
              to="/newabha"
              className={classes.button}
            >
              NO
            </Button>
          </Grid>
        </Grid>

        {/* </Paper>       */}
      </React.Fragment>
    );
  }
}

RegisterAbha.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RegisterAbha);
